export default __webpack_public_path__ + "static/media/Inspection.0bf0c882.svg";